import type { JSXConvertersFunction } from '@payloadcms/richtext-lexical/react'
import type { Media } from '@/payload-types'
import { mediaUrl } from '@/lib/seo/jsonld'

/**
 * Converters per <RichText> dell'articolo. Override SOLO del nodo `upload`: quello di
 * default usa l'URL LOCALe del media (uploadDoc.url), ma qui i media vivono su Bunny —
 * coerentemente con la featured image usiamo mediaUrl() (preferisce bunnyUrl).
 * Le inline immagini sono inserite dal backfill (scripts/backfill-media.ts).
 */
export const articleConverters: JSXConvertersFunction = ({ defaultConverters }) => ({
  ...defaultConverters,
  upload: ({ node }) => {
    const doc = node?.value
    if (!doc || typeof doc !== 'object') return null
    const media = doc as Media
    const src = mediaUrl(media)
    if (!src) return null
    const alt = (node.fields as { alt?: string } | null)?.alt || media.alt || media.caption || ''
    const caption = media.caption
    return (
      <figure className="my-8">
        {/* eslint-disable-next-line @next/next/no-img-element -- inline da CDN, dimensioni arbitrarie */}
        <img
          src={src}
          alt={alt}
          width={media.width ?? undefined}
          height={media.height ?? undefined}
          loading="lazy"
          decoding="async"
          className="w-full rounded-card"
        />
        {caption ? <figcaption className="mt-2 text-center text-sm text-zinc-500">{caption}</figcaption> : null}
      </figure>
    )
  },
})
